import React from 'react';
import { emojiMapStyling } from './style';
import { View } from '../react-native-components';

const OtaIcon = ({ source }) => {
  const styles = emojiMapStyling();
  function renderOtaIcon() {
    switch (source) {
      case 'BOOKING':
      case 'TRIPADVISOR':
      case 'HOTELS':
        return (
          <svg
            aria-label='Hotels.com'
            data-testid='HotelsLogo'
            role='img'
            viewBox='0 0 20 20'
            height={'35'}
            width={'35'}
            className='sc-1d4iol7-0 fSiweQ'>
            <g fill='#CC2B31'>
              <path d='M11.18 6.13V6 4a1.56 1.56 0 0 1 .65-1.34 1.58 1.58 0 0 1 1.87.07 1.94 1.94 0 0 1 .78 1.59v8.16a1.74 1.74 0 0 1-1.43 1.78A1.56 1.56 0 0 1 11.26 13a2.85 2.85 0 0 1-.08-.7v-2.1H8v2.43a2 2 0 0 1-1.65 1.85 1.9 1.9 0 0 1-1.86-.67 1.64 1.64 0 0 1-.41-1.08V3.25a1.71 1.71 0 0 1 1.35-1.67A2.18 2.18 0 0 1 8 3.33a1.07 1.07 0 0 1 0 .18v2.26C8 6 8 6 8.22 6l2.21.13c.24.01.49 0 .75 0z'></path>
              <path d='M4.41 14.27A1.69 1.69 0 0 1 2.79 13a2.29 2.29 0 0 1 0-.47V4.06a1.94 1.94 0 0 1 .15-.9 1.58 1.58 0 0 1 1.05-.83 4.3 4.3 0 0 0-.2 1.94v8.38a2.09 2.09 0 0 0 .57 1.49l.06.07zM2.62 3a2.4 2.4 0 0 0-.21 1.23v8.25a2.22 2.22 0 0 0 .34 1.28 1.29 1.29 0 0 1-.69-.32 1.43 1.43 0 0 1-.56-1.13v-8A1.4 1.4 0 0 1 2.62 3zM10.86 10.54v1.79a2.21 2.21 0 0 0 .56 1.67 1.42 1.42 0 0 1-.87-.57 1.67 1.67 0 0 1-.35-1.07v-1.61c0-.13 0-.17.17-.17zM10.86 5.81h-.66V4.26a1.43 1.43 0 0 1 .39-1 2.48 2.48 0 0 1 .54-.39 3.23 3.23 0 0 0-.27 1.77c-.01.36 0 .73 0 1.17zM10.11 13.42a1.17 1.17 0 0 1-.79-.77 1.54 1.54 0 0 1-.08-.48v-1.54-.09h.61V11.95a3 3 0 0 0 .26 1.47zM10.21 3.1a2 2 0 0 0-.34 1.21v1.44h-.62V5.6 4.28a1.2 1.2 0 0 1 .96-1.18z'></path>
            </g>
          </svg>
        );

      case 'GOOGLE':
        return (
          <svg
            aria-label='Google Local'
            data-testid='GoogleLocalLogo'
            role='img'
            viewBox='0 0 20 20'
            height={'35'}
            width={'35'}
            className='sc-1d4iol7-0 fSiweQ'>
            <path
              fill='#DB4437'
              d='M5.5,0 C2.46243388,-1.90381056e-16 3.71994563e-16,2.52047104 0,5.62962963 C0,8.73876543 4.17324561,14 5.5,16 C7.04385965,13.9012346 11,8.73876543 11,5.62962963 C11,2.52047104 8.53756612,1.90381056e-16 5.5,0 Z M5.5,8 C4.30096074,8 3.32894737,7.00507722 3.32894737,5.77777778 C3.32894737,4.55047833 4.30096074,3.55555556 5.5,3.55555556 C6.69903926,3.55555556 7.67105263,4.55047833 7.67105263,5.77777778 C7.67105263,7.00507722 6.69903926,8 5.5,8 Z'></path>
          </svg>
        );
      case 'EXPEDIA':
        return (
          <svg
            aria-label='Expedia'
            data-testid='ExpediaLogo'
            role='img'
            viewBox='0 0 20 20'
            height={'35'}
            width={'35'}
            className='sc-1d4iol7-0 fSiweQ'>
            <g fill='#072F54'>
              <path d='M9.34664101,6.13627301 L9.02831338,5.22870062 L6.29205036,1.57809229 L6.7797012,1.45617958 L11.4868863,5.52670947 L14.257014,4.73427686 C14.5821146,4.65300172 14.9546256,4.63268293 15.2323157,4.63268293 C14.3653809,2.7565818 12.7669698,1.21235416 10.667362,0.46733205 C6.51555699,-1.01593924 1.94383041,1.15817073 0.46733205,5.31674869 C0.00677292827,6.60360506 -0.0948209957,7.931099 0.0948209957,9.19086366 L6.72551777,6.88806805 L9.34664101,6.13627301 Z'></path>
              <path d='M15.5303245,5.35061333 C15.2864991,5.50639068 14.9275339,5.71635146 14.5753416,5.83149124 L11.798441,6.62392385 L9.94943162,12.5705549 L9.46855372,12.7263322 L9.86138356,8.18847027 L9.64464985,7.24703325 L7.0438454,7.99205536 L0.162550278,9.59723935 C0.711157468,12.2386814 2.58048567,14.5482499 5.30997576,15.5167787 C9.46855372,17.00005 14.0335074,14.82594 15.5167787,10.667362 C16.1534339,8.88608189 16.1127963,7.01675368 15.5303245,5.35061333'></path>
            </g>
            <path
              fill='#FBC108'
              d='M9.63787692,7.24026032 L9.85461063,8.18169735 L9.46178079,12.7195593 L9.9426587,12.5637819 L11.7916681,6.61715092 L14.5685687,5.82471831 C14.920761,5.70957853 15.2797262,5.50639068 15.5235516,5.3438404 C15.4355035,5.10001499 15.3406825,4.8629625 15.2323157,4.62591001 C14.9478527,4.62591001 14.5821146,4.63945586 14.257014,4.72750393 L11.4868863,5.51993654 L6.7797012,1.44940665 L6.29205036,1.57131936 L9.02154045,5.22192769 L9.33986808,6.12950008 L6.71874484,6.88129512 L0.0880480675,9.18409073 C0.108366852,9.3195493 0.135458565,9.46178079 0.162550278,9.59723935 L7.03707247,7.9785095 L9.63787692,7.24026032 L9.63787692,7.24026032 Z'></path>
          </svg>
        );

      default:
        return null;
    }
  }
  return <View style={styles.container}>{renderOtaIcon()}</View>;
};

export default OtaIcon;
